import React from 'react'
import logo from '../../../assets/static/logo-cometa.png'

const LogotipoCometa = () => <img src={logo} alt="Logotipo Cometa" />

export default LogotipoCometa
